import React from "react";
import WindowFormsMyDashboard from "./WindowFormsMyDashboard";
import { titleCaseName } from "./WindowFormShared";

const quoterOf = (entry) => entry?.assigned_to?.name || "Unassigned";

// Salesperson view: window RFQs I submitted.
const WindowFormsSalesDashboard = () => (
  <WindowFormsMyDashboard
    heading="My Window RFQs"
    subtitle="Your submitted window RFQs — quotes to approve, revisions requested, and progress."
    fetchMode="sales"
    detailBase="/windowdoor/sales/windowforms"
    actionStatuses={["Awaiting Sales Approval", "Needs Revision"]}
    waitingStatuses={["Submitted", "Under Review", "Reviewing Revisions"]}
    doneStatuses={["Approved", "Converted to Order"]}
    waitingLabel="With the window team"
    attentionHints={{
      "Awaiting Sales Approval": "Quote ready — open to approve or decline.",
      "Needs Revision":
        "The window team needs changes — open to revise the RFQ.",
    }}
    extraColumn={{
      title: "Assigned Quoter",
      customFilterAndSearch: (term, rowData) =>
        quoterOf(rowData).toLowerCase().includes(term.toLowerCase()),
      customSort: (a, b) => quoterOf(a).localeCompare(quoterOf(b)),
      render: (rowData) => titleCaseName(quoterOf(rowData)),
    }}
    emptyMessage="You haven't submitted any window RFQs yet."
  />
);

export default WindowFormsSalesDashboard;
